module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/24ee36fed99a13e5b019085b51933a2c.png";